import React from 'react';
import styles from './home.module.css'




function Home() {
    return (
    <section className={styles.home}>
        <p></p>
    </section>
)
}

export default Home